export default "__VITE_ASSET__XFv8VFji__"